allow-visible-on-all-workspaces:
  title: すべてのワークスペースで表示
  description: ウィンドウをすべてのワークスペースで表示可能にします。macOSのみ。
spotlight:
  errors:
    unknown: 不明なエラー
    prefix: '問題が発生しました: {message}'
    shortcutRegistrationFailed: '問題が発生しました: Spotlight ショートカットを登録できませんでした。'
pages:
  modules:
    mcp-server:
      description: MCPサーバーとツールの接続と管理
      title: MCPサーバー
  system:
    sections:
      section:
        window-shortcuts:
          title: キーボードショートカット
    window-shortcuts:
      description: ウィンドウ用ショートカットを変更します。
      title: ウィンドウショートカット
      empty: 未設定
      spotlight:
        title: Spotlight ショートカット
        description: ショートカットをクリックしてから新しいショートカットを押します。Esc でキャンセルします。
      actions:
        recording: キーを押してください
        reset: リセット
      errors:
        load: ショートカットを読み込めませんでした
        conflict: このショートカットは使用中です。
        failed: ショートカットの更新に失敗しました
        requiresModifier: Cmd、Ctrl、Alt、Super のいずれかを少なくとも 1 つ使用してください。
      toggle-move:
        label: 移動の切り替え
      toggle-resize:
        label: サイズ変更の切り替え
      toggle-ignore-mouse-event:
        label: マウスイベント無視の切り替え
      press-keys: 何かキーを押してください…
    desktop-control:
      title: Desktop Control
      description: Allow the agent to control mouse, keyboard, and clipboard on this computer.
      section:
        title: Agent desktop control
        description: >-
          When enabled, chat tools can inject mouse and keyboard input.
          By default every action still asks for OS confirmation.
      enabled:
        label: Enable desktop control
        description: Master switch. Keep off unless you want the agent to operate this PC.
      always-allow:
        label: Always allow (dangerous)
        description: >-
          Skip the OS confirmation dialog for every action.
          Only use this if you fully trust the model and your setup.
        toast: Always-allow is on. Desktop actions will not ask for confirmation.
      emergency-stop:
        title: Emergency stop is active
        description: >-
          Desktop injection is blocked. Clear emergency stop, then turn the master switch on again if needed.
          Shortcut: Ctrl/Cmd+Shift+F12.
        clear: Clear emergency stop
        cleared: Emergency stop cleared
      hints:
        emergency-shortcut: Emergency stop shortcut is Ctrl+Shift+F12 (Cmd+Shift+F12 on macOS).
      errors:
        load: Failed to load desktop control settings
        save: Failed to update desktop control settings
    developer:
      sections:
        section:
          use-window-mouse:
            title: ウィンドウマウス ツールを使用
            description: Electronウィンドウのカーソル位置をテストします
devtools:
  title: 開発者
  pages:
    context-flow:
      title: コンテキストのフロー
    lag-visualizer:
      title: ラグビジュアライザー
    performance-visualizer:
      title: パフォーマンスビジュアライザー
      description: FPS/ロングタスク/メモリーオーバーレイの切り替え
    markdown-stress:
      title: Markdown ストレス
      description: 大量のチャットデータを含むMarkdownの解析とレンダリング負荷のテスト
    io-tracer:
      title: IO Tracer
    widgets-calling:
      title: ウィジェット呼び出し
screen-capture:
  permissions-prompt:
    title: 画面キャプチャ
    description: 画面またはウィンドウをキャプチャするには、画面とシステムのオーディオ録音の許可が必要です。
    open-preferences: システム設定を開く
    dismiss: 閉じる
    instructions:
      step-1: '「システム設定」を開き、サイドバーから「プライバシーとセキュリティ」を選択します。'
      step-2: '「画面&システム音声録音」および「システム音声録音のみ」のセクションで、AIRI用のスイッチをオンにしてください。'
      step-2-note: AIRIが表示されていない場合は、「+」ボタンをクリックして「アプリケーション」フォルダから「AIRI」を選択して手動で追加してください。
